import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Badge } from 'primereact/badge';
import { useAnalyticsContext } from 'providers/AnalyticProvider';
import usePageInfo from 'utility/hooks/usePageInfo';
import { EXTERNAL_LINK_CLICK } from 'constants/analyticEvents';
import { BETA_ITEMS, SUB_MENU_PATH } from '../constants/routeDetails';
import { clip } from '../../../assets/icons';

/**
 *
 * @param {'PortfolioHealthMenu'|'Help'} parentName - should be values of `MENU_ID`
 * @returns
 */
const useMenuSubItems = (parentName, handleBrandCrumb = () => {}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const analytics = useAnalyticsContext();
  const { moduleName, pageName } = usePageInfo();

  const handleClick = (text, link) => {
    analytics?.sendGAEvent(EXTERNAL_LINK_CLICK, {
      link_url: link,
      link_label: text,
      module_name: moduleName,
      page_name: pageName,
      section_name: 'Help',
    });
  };

  /**
   * @type {import('primereact/menuitem').MenuItem[]}
   */
  const items = useMemo(
    () =>
      SUB_MENU_PATH[parentName]
        .filter((item) => !item.disabled)
        .map((item) => ({
          template: (templateItem, options) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              role="menuitem"
              tabIndex={options.tabIndex}
              className={options.className}
              target={templateItem.target}
              onClick={options.onClick}
              data-testid="menu-item"
            >
              {!!item.newTab && item.leftIcon && (
                <img
                  data-testid="new-tab-icon"
                  src={clip}
                  className="me-2"
                  alt="clip"
                />
              )}
              <span className={options.labelClassName}>
                {item.name}
                {BETA_ITEMS.includes(item.name) && (
                  <Badge
                    data-testid="beta-badge"
                    className="ms-1"
                    value="Beta"
                    severity="success"
                  />
                )}
              </span>
              {!!item.newTab && !item.leftIcon && (
                <img
                  data-testid="new-tab-icon"
                  src={clip}
                  className="ms-2"
                  alt="clip"
                />
              )}
            </a>
          ),
          command: () => {
            if (item.newTab) {
              handleClick(item.name, item.path);
              window.open(item.path, '_blank');
              return;
            }
            handleBrandCrumb();
            navigate(item.path);
          },
          className: location.pathname === item.path ? 'active' : '',
        })),
    [parentName, location.pathname, navigate],
  );

  return items;
};

export default useMenuSubItems;
